export default __webpack_public_path__ + "static/media/9_16-story-combined.6f6fb79d.png";